const tiles = [
  {
    id: '0',
    title: 'Add Tile',
    description: 'Add new tiles from the list of available tiles.',
    icon: 'AddRounded',
    action: 'add-tile',
    styles: {
      color: 'text.secondary',
      backgroundColor: '#e1f5fe',
      border: '1px dashed',
      borderColor: '#29b6f6',
    },
  },
  {
    id: '1',
    title: 'Start Return',
    description: 'Start a return manually or by scanning a receipt.',
    icon: 'ArrowBackRounded',
    action: 'start-return',
    styles: { backgroundColor: '#d84315', color: '#ffffff' },
  },
  {
    id: '2',
    title: 'Ship to customer',
    description: 'Ship selected items to customer.',
    icon: 'LocalShippingRounded',
    action: 'ship-to-customer',
    styles: { backgroundColor: '#1565C0', color: '#ffffff' },
  },
  {
    id: '3',
    title: 'Add a discount',
    description: 'Manually add a discount to the cart.',
    icon: 'PercentRounded',
    action: 'add-discount',
    styles: { backgroundColor: '#FF8F00', color: '#ffffff' },
  },
  {
    id: '4',
    title: 'Manual Item',
    description: 'Create a custom line item.',
    icon: 'AddBoxRounded',
    action: 'add-manual-item',
    styles: { backgroundColor: '#2E7D32', color: '#ffffff' },
  },
  {
    id: '5',
    title: 'Gift Card Balance',
    description: 'Check a gift card balance.',
    icon: 'CardGiftcardRounded',
    action: 'check-gift-card-balance',
    styles: { backgroundColor: '#1565C0', color: '#ffffff' },
  },
  {
    id: '6',
    title: 'RePrint Receipt',
    description: 'Find previous order and print or send the receipt.',
    icon: 'PrintRounded',
    action: 're-print-receipt',
    styles: { backgroundColor: '#1565C0', color: '#ffffff' },
  },
  {
    id: '7',
    title: 'Send as Quote',
    description: 'Send or print the current cart as a quote.',
    icon: 'StarRate',
    action: 'send-a-quote',
    styles: { backgroundColor: '#1565C0', color: '#ffffff' },
  },
  {
    id: '8',
    title: 'Assign Customer',
    description: 'Assign customer to this checkout.',
    icon: 'Accessibility',
    action: 'assign-customer',
    styles: { backgroundColor: '#1565C0', color: '#ffffff' },
  },
  {
    id: '9',
    title: 'Cash',
    description: 'Create a cash payment',
    icon: 'AddBoxRounded',
    action: 'payment-cash',
    styles: { backgroundColor: '#2E7D32', color: '#ffffff' },
  },
  {
    id: '10',
    title: 'External Payment',
    description: 'Use external terminal to process payment.',
    icon: 'AddBoxRounded',
    action: 'payment-external-terminal',
    styles: { backgroundColor: '#2E7D32', color: '#ffffff' },
  },
];

export default tiles;
